import React from 'react';
import { Title } from './Title';
import { UndraggableImage } from 'components/shared/UndraggableImage';
import Steps from 'assets/steps.png';
import { Center } from 'components/shared/Center';
import { ListItem } from '@chakra-ui/layout';
import { StyledList } from './StyledList';
import { Link } from 'components/shared/Link';
import { Flex } from '@chakra-ui/react';

export const DeliveryNotice = React.memo(() => {
  return (
    <Flex id="送貨須知" flexDirection="column">
      <Title>送貨須知</Title>
      <Center>
        <UndraggableImage width="100%" src={Steps} maxWidth={830} />
      </Center>
      <StyledList>
        <ListItem>會員必須保留已預購家電之完整收據。</ListItem>
        <ListItem>
          交易後3個工作天內，會員需填妥電子
          <Link
            href="http://www.hungfooktong.com/member/germanpooljp/deliveryeform/orderform.html"
            target="_blank"
          >
            送貨表格
          </Link>
          。
        </ListItem>
        <ListItem>
          德國寶(香港)有限公司會根據收據編號及已登記之送貨地址，於成功登記電子送貨表格後12個工作天內送貨。
        </ListItem>
        <ListItem>
          離島、愉景灣、沒有電梯之樓房（如唐樓）及送貨車輛未能到達的地方不設送貨。
        </ListItem>
        <ListItem>
          如會員未有於指定時間內登記電子送貨表格，交易會被取消。
        </ListItem>
        <ListItem>
          交易取消後，已兌換之積分(如適用)並不作補回。預購家電之金額將於推廣期完結後，10個工作天內退回到會員卡（推廣所獲贈之購物e券及積分亦會同時扣除，如贈券及積分已被使用，將會扣除同等價值之儲值額），恕不另行通知。
        </ListItem>
      </StyledList>
    </Flex>
  );
});
